import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UUID } from "@onsip/common/libraries/sip";
import { PublicWebCallTopic } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic";
import { WebCallTopicService } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic.service";
import { views } from "@onsip/web/app/phone/views";

import { of, NEVER } from "rxjs";

@Injectable({ providedIn: "root" })
export class TopicResolver {
  constructor(private router: Router, private webCallTopicService: WebCallTopicService) {}

  resolve() {
    const currentNavigation = this.router.getCurrentNavigation();
    if (!currentNavigation) throw new Error("TopicResolverService: currentNavigation undefined");
    if (currentNavigation.extras.state && currentNavigation.extras.state.topicTarget) {
      const topicTarget: string = currentNavigation.extras.state.topicTarget;
      if (currentNavigation.trigger === "imperative") {
        let found = this.webCallTopicService.findTopic(topicTarget);
        // make sure found is a copy or we would be modifying the original target.
        if (found) found = JSON.parse(JSON.stringify(found));
        if (found && found.configuration) {
          if (
            currentNavigation.finalUrl &&
            currentNavigation.finalUrl.toString() === views.SAYSO_DUPLICATE
          ) {
            found.configuration.target = addDigits(found.configuration.target, true);
            found.configuration.targetDisplay = addDigits(found.configuration.targetDisplay, false);
            found.configuration.uuid = UUID.randomUUID();
          }
          const topic: PublicWebCallTopic = {
            configuration: found.configuration,
            filters: found.configuration.filters,
            webCallTopicReps: found.webCallTopicReps
          };
          return of(topic); // doesn't work if we simply return found.state. sad!
        } // else failover
      } else {
        // prevent going back to add/edit via forward/back
        this.router.navigate([views.SAYSO_VIEW], { state: { topicTarget } });
        return NEVER;
      }
    }
    // failover case - either
    this.router.navigate([views.SAYSO_SETTINGS]);
    return NEVER;
  }
}

/**
 * @param useDash {boolean} true if for target and false if for targetDisplay
 */
function addDigits(myString: string, useDash: boolean) {
  let newString: string;
  if (/\d+$/.test(myString)) {
    newString = myString.replace(/\d+$/, match => "" + (parseInt(match) + 1));
    return newString.replace(
      /(.{0,24})(.*?)(\d+$)/,
      (_match, grp1, _grp2, grp3) => grp1.slice(0, 24 - grp3.length) + grp3
    );
  } else {
    return myString.slice(0, 22) + (useDash ? "-2" : " 2");
  }
}
